import { Box, Paper, Stack } from "@mui/material";
import type { PropsWithChildren } from "react";
import UpdateAppPopover from "@entrilia/shared/components/UpdateAppPopover";
import LeftSideRootMenu from "./components/leftSideMenu/LeftSideRootMenu";

const Main = ({ children }: PropsWithChildren) => (
  <Box component="main" sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: "100%", minHeight: 0 }}>
    <UpdateAppPopover cooldownInMinutes={5} />
    <Stack direction="row" sx={{ alignItems: "stretch", width: "100%", flexGrow: 1, minHeight: 0 }}>
      <LeftSideRootMenu />
      <Paper
        elevation={0}
        sx={() => ({
          py: 0,
          pl: 0,
          flexGrow: 1,
          height: "100%",
        })}
      >
        <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>{children}</Box>
      </Paper>
    </Stack>
  </Box>
);

export default Main;
